import type { WorkOrderMtrInflationData, WorkOrderPriceData, WorkOrderPriceItem } from 'gql/graphql';
import { OtherCostCalculationTypeEnum, WorkOrderPriceTypeEnum, WorkOrderStatusEnum } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { RowClassRules, ValueGetterParams } from 'ag-grid-community';

export const getUerRowClass = (workOrderStatus?: WorkOrderStatusEnum | undefined): RowClassRules => ({
    UER: ({ data }: { data: WorkOrderMtrInflationData | WorkOrderPriceData }) =>
        data?.type === WorkOrderPriceTypeEnum.Uer,
    COEFFICIENT: ({ data }: { data: WorkOrderMtrInflationData | WorkOrderPriceData }) =>
        data?.type === WorkOrderPriceTypeEnum.Coefficient ||
        data?.type === WorkOrderPriceTypeEnum.ConstraintCoefficient ||
        data?.type === WorkOrderPriceTypeEnum.TechPartCoefficient,
    MTR_CONTRACTOR_MATERIAL: ({ data }: { data: WorkOrderMtrInflationData | WorkOrderPriceData }) =>
        data?.type === WorkOrderPriceTypeEnum.MtrContractorMaterial,
    MTR_CUSTOMER_MATERIAL: ({ data }: { data: WorkOrderMtrInflationData | WorkOrderPriceData }) =>
        data?.type === WorkOrderPriceTypeEnum.MtrCustomerMaterial,
    MTR_CONTRACTOR_EQUIPMENT: ({ data }: { data: WorkOrderMtrInflationData | WorkOrderPriceData }) =>
        data?.type === WorkOrderPriceTypeEnum.MtrContractorEquipment,
    MTR_CUSTOMER_EQUIPMENT: ({ data }: { data: WorkOrderMtrInflationData | WorkOrderPriceData }) =>
        data?.type === WorkOrderPriceTypeEnum.MtrCustomerEquipment,
    alert: ({ data }: { data: WorkOrderPriceData }) =>
        !data?.isActKC2Price &&
        [
            WorkOrderPriceTypeEnum.Uer,
            WorkOrderPriceTypeEnum.Mtr,
            WorkOrderPriceTypeEnum.MtrCustomerMaterial,
            WorkOrderPriceTypeEnum.MtrCustomerEquipment,
            WorkOrderPriceTypeEnum.MtrContractorMaterial,
            WorkOrderPriceTypeEnum.MtrCustomerEquipment,
        ].includes(data?.type) &&
        !!(data?.hasEmptySeasonVolume && workOrderStatus === WorkOrderStatusEnum.OnFormation),
});

export const getWorkOrderUnitCellValue = <T extends WorkOrderPriceItem>(props: ValueGetterParams<T, any>): string => {
    const { data } = props;

    if (data?.isOtherItem && data?.calculatingType === OtherCostCalculationTypeEnum.Percent) {
        return data?.calculatingTypeValue ? `${formatNumberToRu(data?.calculatingTypeValue, 2)}%` : '';
    }

    return data?.unit ?? '';
};
